import styled from 'styled-components'
import { P } from '../StyledText'

export const StyledMenuText = styled(P)`
  font-family: knowledge2017medium;
` as React.ComponentType<any>
